import React, { useEffect } from 'react';
import { resetPreopenClaim } from 'containers/PreOpeningPage/actions';
import {
  requestGetReportsPolicy,
  resetUploadDocumentStore,
} from 'containers/UploadDocuments/actions';
import SearchContainer from 'containers/IdentificationPage/SearchContainer';
import {
  requestFindClaims,
  requestSearchClaims,
  setLossDate,
  requestSupportDocuments,
  setSelectedClaim,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { connect } from 'react-redux';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import Stepper from 'containers/AppContainer/Stepper';
import { SearchClaims } from 'containers/IdentificationPage/typings';
import { CLAIM_STATUS } from 'containers/data-structure';
import { isEmpty } from 'lodash';
import ClaimWithNotIndexedPV from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV';
import {
  isClaimRejected,
  shouldDisplayExistingClaimIndexationPanel,
  shouldDisplaySearchResult,
} from 'containers/IdentificationPage/utils';
import { createStructuredSelector } from 'reselect';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import SearchResults from 'containers/IdentificationPage/SearchResults';
import currentUserStorage from 'containers/services/security/current-user-storage';

export interface IdentificationPageManagerProps {
  requestFindClaims: Function;
  requestSearchClaims: Function;
  setLossDate: Function;
  searchClaims: any;
  listings: any;
  setSelectedClaim: any;
  requestSupportDocuments: Function;
  resetPreopenClaim: Function;
  resetSearchClaimsStore: Function;
  resetUploadDocumentStore: Function;
  requestGetReportsPolicy: Function;
}

const IdentificationManagerPage: React.FC<IdentificationPageManagerProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    props.resetPreopenClaim();
    props.resetSearchClaimsStore();

    // empty store on unmount
    return () => {
      props.resetUploadDocumentStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [searchQuery, setSearchQuery] = React.useState({
    lossDate: null,
    registrationNumber: null,
    policyNumber: null,
    claimNumber: null,
    assuredCIN: null,
    assuredName: null,
    victimName: null,
    courtNumber: null,
    withDocuments: 'Y',
  } as any);

  const submitSearch = () => {
    props.requestFindClaims(searchQuery);
    props.requestSearchClaims(searchQuery);
    props.setLossDate(searchQuery.lossDate);
  };

  const enablePreOpenClaim = (searchClaims: SearchClaims) => {
    let creator: string[] = [];
    if (
      isEmpty(
        searchClaims.corporeal?.filter(
          c =>
            c.status === CLAIM_STATUS.PENDING ||
            c.status === CLAIM_STATUS.PENDING_INFO_MODIFICATION ||
            c.status === CLAIM_STATUS.PENDING_APPROVAL ||
            c.status === CLAIM_STATUS.VALIDATED,
        ),
      )
    ) {
      creator = searchClaims.corporeal
        ?.filter(c => c.status === CLAIM_STATUS.REJECTED)
        .map(c => c.createdBy);
      if (
        !isEmpty(creator) &&
        creator.includes(currentUserStorage.get()?.username)
      ) {
        return !featureService.hasFeature(
          FEATURES.LAWYER_REJECTED_CLAIM_UPDATE,
        );
      }
      return true;
    }
    return false;
  };
  return (
    <div>
      <Stepper isPreOpeningManager />
      <SearchContainer
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        submitSearch={submitSearch}
        isManager={false}
      />
      {shouldDisplayExistingClaimIndexationPanel(props.searchClaims) && (
        <ClaimWithNotIndexedPV
          corporealClaimDetails={props.searchClaims}
          listings={props.listings}
          setSelectedClaim={props.setSelectedClaim}
          enablePreOpenClaim={enablePreOpenClaim(props.searchClaims)}
          isPreOpeningManager={true}
          requestSearchClaims={props.requestSearchClaims}
        />
      )}
      {shouldDisplaySearchResult(props.listings, props.searchClaims) && (
        <SearchResults
          policyExists={!isEmpty(props.searchClaims?.sagis?.policy)}
          claimExists={
            !isEmpty(props.searchClaims.corporeal) &&
            !isClaimRejected(props.searchClaims)
          }
          searchClaim={props.searchClaims}
          requestSupportDocuments={props.requestSupportDocuments}
          enablePreOpenClaim={enablePreOpenClaim(props.searchClaims)}
          isPreOpeningManager={true}
          listings={props.listings}
          requestGetReportsPolicy={props.requestGetReportsPolicy}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = {
  requestFindClaims,
  requestSearchClaims,
  setLossDate,
  requestSupportDocuments,
  setSelectedClaim,
  resetPreopenClaim,
  resetSearchClaimsStore,
  resetUploadDocumentStore,
  requestGetReportsPolicy,
};
const mapStateToProps = createStructuredSelector({
  searchClaims: makeSelectSearchClaims(),
  listings: makeSelectListings(),
});
export { IdentificationManagerPage as IdentificationManagerPageTest };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IdentificationManagerPage);
